import { Product } from '../../types';

export const series0110Products: Product[] = [
  {
    id: "bt-0110-swt011001m",
    name: "0110 Series Terminal - 2.8 Male Lock (SWT011001M)",
    slug: "0110-series-terminal-2-8-male-lock-swt011001m",
    category: "Brass Terminal",
    subcategory: "0110 Series",
    description: "2.8mm male lock terminal for automotive connectors. High conductivity brass construction with locking mechanism.",
    partNumber: "SWT011001M",
    featured: true,
    specifications: {
      "Tab Size Ø": "2.8 mm",
      "Cable Size SQ. MM": "1.40-2.10",
      "Description": "2.8 Male Lock",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-10000 Cut-1000",
    },
    images: ["/products/brass-terminals/0110-series/SWT011001M.jpg"],
    tags: ["terminal", "0110", "brass", "male", "lock", "2.8mm"],
    applications: ["Automotive", "Connectors"],
  },
  {
    id: "bt-0110-swt011002m",
    name: "0110 Series Terminal - 2.8 Male Lock Side Feed (SWT011002M)",
    slug: "0110-series-terminal-2-8-male-lock-side-feed-swt011002m",
    category: "Brass Terminal",
    subcategory: "0110 Series",
    description: "2.8mm male lock terminal with side feed crimping design. High conductivity brass construction.",
    partNumber: "SWT011002M",
    specifications: {
      "Tab Size Ø": "2.8 mm",
      "Cable Size SQ. MM": "1.40-2.10",
      "Description": "2.8 Male Lock Side Feed",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/0110-series/SWT011002M.jpg"],
    tags: ["terminal", "0110", "brass", "male", "lock", "side-feed", "2.8mm"],
    applications: ["Automotive", "Connectors"],
  },
  {
    id: "bt-0110-swt011003m",
    name: "0110 Series Terminal - 2.8 Male Lock Zigzag (SWT011003M)",
    slug: "0110-series-terminal-2-8-male-lock-zigzag-swt011003m",
    category: "Brass Terminal",
    subcategory: "0110 Series",
    description: "2.8mm male lock terminal with zigzag pattern on crimp barrel. High conductivity brass construction.",
    partNumber: "SWT011003M",
    specifications: {
      "Tab Size Ø": "2.8 mm",
      "Cable Size SQ. MM": "1.40-2.10",
      "Description": "2.8 Male Lock Zigzag",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-10000 Cut-1000",
    },
    images: ["/products/brass-terminals/0110-series/SWT011003M.jpg"],
    tags: ["terminal", "0110", "brass", "male", "lock", "zigzag", "2.8mm"],
    applications: ["Automotive", "Connectors"],
  },
  {
    id: "bt-0110-swt011004m",
    name: "0110 Series Terminal - 2.8 Male Plain (SWT011004M)",
    slug: "0110-series-terminal-2-8-male-plain-swt011004m",
    category: "Brass Terminal",
    subcategory: "0110 Series",
    description: "2.8mm male plain terminal with standard crimp barrel. High conductivity brass construction.",
    partNumber: "SWT011004M",
    specifications: {
      "Tab Size Ø": "2.8 mm",
      "Cable Size SQ. MM": "1.40-2.10",
      "Description": "2.8 Male Plain",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-10000 Cut-1000",
    },
    images: ["/products/brass-terminals/0110-series/SWT011004M.jpg"],
    tags: ["terminal", "0110", "brass", "male", "plain", "2.8mm"],
    applications: ["Automotive", "Connectors"],
  },
  {
    id: "bt-0110-swt011004f",
    name: "0110 Series Terminal - 3.2 Female Lock (SWT011004F)",
    slug: "0110-series-terminal-3-2-female-lock-swt011004f",
    category: "Brass Terminal",
    subcategory: "0110 Series",
    description: "3.2mm female lock terminal with locking mechanism. Designed to receive male tab connectors.",
    partNumber: "SWT011004F",
    specifications: {
      "Tab Size Ø": "3.2 mm",
      "Cable Size SQ. MM": "1.40-2.10",
      "Description": "3.2 Female Lock",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3000 Cut-1000",
    },
    images: ["/products/brass-terminals/0110-series/SWT011004F.jpg"],
    tags: ["terminal", "0110", "brass", "female", "lock", "3.2mm"],
    applications: ["Automotive", "Connectors"],
  },
  {
    id: "bt-0110-swt011005f",
    name: "0110 Series Terminal - 2.8 Female Dimple (SWT011005F)",
    slug: "0110-series-terminal-2-8-female-dimple-swt011005f",
    category: "Brass Terminal",
    subcategory: "0110 Series",
    description: "2.8mm female terminal with dimple retention feature. High conductivity brass construction.",
    partNumber: "SWT011005F",
    specifications: {
      "Tab Size Ø": "2.8 mm",
      "Cable Size SQ. MM": "1.40-2.10",
      "Description": "2.8 Female Dimple",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-10000 Cut-1000",
    },
    images: ["/products/brass-terminals/0110-series/SWT011005F.jpg"],
    tags: ["terminal", "0110", "brass", "female", "dimple", "2.8mm"],
    applications: ["Automotive", "Connectors"],
  },
  {
    id: "bt-0110-swt011006f",
    name: "0110 Series Terminal - Butterfly Female (SWT011006F)",
    slug: "0110-series-terminal-butterfly-female-swt011006f",
    category: "Brass Terminal",
    subcategory: "0110 Series",
    description: "Butterfly female terminal with distinctive butterfly-shaped crimp barrel. High conductivity brass construction.",
    partNumber: "SWT011006F",
    specifications: {
      "Tab Size Ø": "2.3 mm",
      "Cable Size SQ. MM": "1.00-2.10",
      "Description": "Butterfly Female",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-7000 Cut-1000",
    },
    images: ["/products/brass-terminals/0110-series/SWT011006F.jpg"],
    tags: ["terminal", "0110", "brass", "female", "butterfly", "2.3mm"],
    applications: ["Automotive", "Connectors"],
  },
];
